export type AspectRatio = `${number}/${number}`;

export type VerticalAlignment = 'top' | 'bottom' | 'center' | 'stretch';

export type ScalingStrategy = 'window' | 'container';
export type ScalingUnit = 'vw' | 'cqw';

const ScalingStrategyToUnitMap: Record<ScalingStrategy, ScalingUnit> = {
  window: 'vw',
  container: 'cqw',
};
export const getScalingUnit = (scalingStrategy: ScalingStrategy): ScalingUnit =>
  ScalingStrategyToUnitMap[scalingStrategy];

/** Thumbnail-driven show/hide of individual report pages. */
export type ReportPageVisibility = {
  /** Keys of pages kept out of the canvas, fullscreen and PDF export. */
  hiddenPageKeys: readonly string[];
  /**
   * Toggle from the eye on a page thumbnail.
   * Omit on read-only reports (shared links) so skipped slides are not listed at all.
   */
  onTogglePageHidden?: (pageKey: string, nextHidden: boolean) => void;
};
